export default {
  brand: {
    name: 'Helper Casino'
  },
  nav: {
    home: 'ホーム',
    live: 'ライブ',
    slots: 'スロット',
    sports: 'スポーツ',
    minigames: 'ミニゲーム',
    mini: 'ミニ',
    fishing: 'フィッシング',
    mypage: 'マイページ',
    deposit: '入金',
    withdraw: '出金',
    event: 'イベント',
    notice: 'お知らせ',
    support: 'カスタマーサポート',
    slip: 'メッセージ',
    betting: 'ベット履歴',
    login: 'ログイン',
    logout: 'ログアウト',
    signup: '新規登録',
    menuOpen: 'メニューを開く',
    menuClose: 'メニューを閉じる',
    telegramInquiry: 'Telegram お問い合わせ',
    mobilePrimary: '主要メニュー'
  },
  maintenance: {
    title: 'メンテナンスのお知らせ',
    defaultMessage: '現在メンテナンス中です。しばらくしてから再度ご利用ください。'
  },
  common: {
    close: '閉じる',
    confirm: '確認',
    backToList: '一覧に戻る',
    loading: '読み込み中...',
    refresh: '更新',
    balanceRefresh: '残高を更新',
    prev: '前へ',
    next: '次へ',
    copySuccess: 'コピーしました。',
    copyFail: 'コピーに失敗しました。',
    telegramMissing: 'Telegram の連絡先がありません。',
    siteLoadError: 'サイト情報を読み込めませんでした。',
    alertTitle: 'お知らせ',
    empty: 'データがありません。',
    noTitle: '（タイトルなし）'
  },
  auth: {
    loginTitle: 'ログイン',
    signupTitle: '新規登録',
    signupDesc: '以下の情報を入力して登録を完了してください。',
    loginId: 'ユーザーID',
    loginIdPlaceholder: 'ユーザーID',
    password: 'パスワード',
    passwordPlaceholder: 'パスワード',
    passwordShow: 'パスワードを表示',
    passwordHide: 'パスワードを非表示',
    loginSubmit: 'ログイン',
    loginSubmitting: 'ログイン中...',
    loginEmptyError: 'ユーザーIDとパスワードを入力してください。',
    loginFail: 'ログインに失敗しました。',
    loginSuccess: 'ログインしました。',
    logoutSuccess: 'ログアウトしました。',
    accountUnavailable: 'ご利用いただけないアカウントです。',
    wrongCredentials: 'IDまたはパスワードが正しくありません。',
    accountNotApproved: '承認されていないアカウントです。',
    sessionExpired: 'ログインの有効期限が切れました。',
    sessionInvalid: 'ログイン情報が無効です。',
    sessionNotFound: 'ログイン情報がありません。再度ログインしてください。',
    sessionDoubleLogin: '別の端末でログインされたため、ログアウトされました。',
    sessionNetwork: 'サーバーに接続できません。再度ログインしてください。',
    signupPrompt: '簡単な登録ですぐにご利用いただけます。',
    signupLink: '新規登録はこちら',
    nickname: 'ニックネーム',
    nicknamePlaceholder: '2〜12文字',
    loginIdRulePlaceholder: '4〜12文字の英数字',
    passwordRulePlaceholder: '4〜20文字',
    passwordConfirm: 'パスワード確認',
    passwordConfirmPlaceholder: 'パスワードを再入力',
    phone: '携帯電話番号',
    sendCode: '認証コード送信',
    resendCode: '再送信',
    confirmCode: '認証確認',
    codePlaceholder: '6桁の認証コード',
    referralCode: '紹介コード',
    referralCodePlaceholder: '紹介コードを入力',
    referralHint: '紹介者IDがわからない場合は',
    referralHintSuffix: 'お問い合わせください。',
    signupSubmit: '新規登録',
    signupSubmitting: '登録処理中...',
    hasAccount: 'すでにアカウントをお持ちですか？',
    goLogin: 'ログインする',
    phoneVerified: '携帯電話認証が完了しました。',
    phoneNeedVerify: '携帯電話認証を完了してください。',
    phoneInvalid: '携帯電話番号を確認してください。',
    phoneSendFail: '認証コードの送信に失敗しました。',
    phoneVerifyFail: '認証コードが正しくありません。',
    phoneNeedCode: '先に認証コードを送信してください。',
    errorLoginIdRequired: 'ユーザーIDを入力してください。',
    errorLoginIdFormat: 'ユーザーIDは4〜12文字の英数字のみ使用できます。',
    errorNicknameRequired: 'ニックネームを入力してください。',
    errorNicknameLength: 'ニックネームは2〜12文字で入力してください。',
    errorPasswordRequired: 'パスワードを入力してください。',
    errorPasswordLength: 'パスワードは4〜20文字で入力してください。',
    errorPasswordConfirmRequired: 'パスワード確認を入力してください。',
    errorPasswordMismatch: 'パスワード確認が一致しません。',
    errorReferralRequired: '紹介コードを入力してください。',
    errorReferralInvalid: '紹介コードを確認してください。',
    errorDuplicateLoginId: 'このユーザーIDは既に使用されています。',
    errorDuplicateNickname: 'このニックネームは既に使用されています。',
    errorDuplicateIp: 'このIPアドレスからは既に登録されています。',
    signupFail: '新規登録に失敗しました。',
    signupSuccess: '登録が完了しました。',
    signupSuccessLogin: '登録が完了しました。ログインしてください。'
  },
  games: {
    hotTitle: '人気ゲーム',
    providersTitle: 'ゲームプロバイダー',
    hotProvidersTitle: '人気プロバイダー',
    hotProvidersSubtitle: 'プロバイダーを選択するとスロット一覧またはライブロビーに移動します。',
    liveTitle: 'ライブ',
    liveSubtitle: 'プロバイダーを選択後、ログインしてロビーに入場します。',
    slotsTitle: 'スロット',
    slotsSubtitle: 'プロバイダーを選択するとログインなしでゲーム一覧を確認できます。',
    sportsTitle: 'スポーツ',
    sportsSubtitle: 'スポーツベット',
    minigameTitle: 'ミニゲーム',
    fishingTitle: 'フィッシング',
    list: 'ゲーム一覧',
    search: 'ゲーム名検索',
    searchPlaceholder: 'キーワードを入力',
    loading: 'ゲーム一覧を読み込み中...',
    loadingProviders: 'プロバイダー一覧を読み込み中...',
    loadingSports: 'スポーツを読み込み中...',
    empty: '表示するゲームがありません。',
    emptyProviders: '表示するプロバイダーがありません。',
    emptySearch: '検索結果がありません。',
    expand: 'もっと見る',
    collapse: '閉じる',
    play: 'プレイ',
    demo: '無料デモ',
    previewTagline: '今すぐプレイするか、無料デモをお試しください。',
    gameCountFiltered: '{shown}件 / 全{total}件',
    gameCountTotal: '全{total}ゲーム',
    sportsPreparing: 'スポーツゲームを準備中です。',
    loadError: 'ゲーム一覧を読み込めませんでした。',
    launchError: 'ゲームの起動に失敗しました。',
    demoError: 'デモの起動に失敗しました。',
    sportsLaunchError: 'スポーツゲームの起動に失敗しました。',
    providerNotFound: 'プロバイダー情報を確認できません。',
    providerNotFoundSports: 'スポーツプロバイダー {provider} が見つかりません。',
    providerNotFoundMinigame: 'プロバイダー {provider} が見つかりません。',
    categorySlot: 'スロット',
    categoryLive: 'ライブ',
    categoryFishing: 'フィッシング',
    categoryMini: 'ミニ',
    categorySports: 'スポーツ',
    categoryAll: 'すべて',
    categoryOther: 'その他'
  },
  jackpot: {
    title: 'メガジャックポット',
    mega: 'MEGA',
    live: 'LIVE · リアルタイム累積'
  },
  popup: {
    aria: 'ポップアップお知らせ',
    hide24h: '24時間表示しない',
    close: '閉じる',
    closeAll: 'すべてのポップアップを閉じる'
  },
  slip: {
    title: 'メッセージ',
    desc: '受信したメッセージを確認できます。',
    loading: 'メッセージを読み込み中...',
    emptyAll: '受信したメッセージがありません。',
    emptyUnread: '未読メッセージがありません。',
    emptyRead: '既読メッセージがありません。',
    loadError: 'メッセージ一覧を読み込めませんでした。',
    reload: '更新',
    reloadAria: 'メッセージ一覧を更新',
    filterAria: 'メッセージフィルター',
    prevPage: '前へ',
    nextPage: '次へ',
    colNo: '番号',
    colStatus: '状態',
    colTitle: '件名',
    colDate: '日付',
    noTitle: '（タイトルなし）',
    unreadCount: '未読 {count}件',
    unreadAria: '未読メッセージ {count}件',
    headerNotice: '未読メッセージがあります。',
    headerNoticeAria: '未読メッセージを見る',
    filterAll: 'すべて',
    filterUnread: '未読',
    filterRead: '既読',
    statusUnread: '未読',
    statusRead: '既読',
    detailLoadError: 'メッセージ内容を読み込めませんでした。',
    detailDefaultTitle: 'メッセージ',
    unreadCheckMessage: '未読メッセージをご確認ください。',
    unreadCheckConfirm: 'メッセージを確認'
  },
  support: {
    title: 'カスタマーサポート',
    desc: '新しいお問い合わせを登録し、履歴を確認できます。',
    composeTitle: 'お問い合わせ',
    fieldTitle: '件名',
    fieldTitlePlaceholder: 'お問い合わせ件名を入力してください',
    fieldContent: '内容',
    fieldContentPlaceholder: 'お問い合わせ内容を入力してください',
    submit: 'お問い合わせ登録',
    submitting: '登録中...',
    historyTitle: 'お問い合わせ履歴',
    historyReloadAria: 'お問い合わせ履歴を更新',
    loading: 'お問い合わせ履歴を読み込み中...',
    loadError: 'お問い合わせ履歴を読み込めませんでした。',
    empty: '登録されたお問い合わせがありません。',
    colNo: '番号',
    colStatus: '状態',
    colTitle: '件名',
    colDate: '日付',
    statusAnswered: '回答済み',
    statusPending: '回答待ち',
    errorTitleRequired: '件名を入力してください。',
    errorContentRequired: '内容を入力してください。',
    submitFail: 'お問い合わせの登録に失敗しました。',
    submitSuccess: 'お問い合わせが登録されました。',
    detailDefaultTitle: 'お問い合わせ詳細',
    detailQuestionTitle: 'お問い合わせ内容',
    detailAnswerTitle: '回答',
    detailAnswerPending: '回答待ちです。',
    detailLoadError: 'お問い合わせ内容を読み込めませんでした。'
  },
  notice: {
    title: 'お知らせ',
    eventTitle: 'イベント',
    tabNotice: 'お知らせ',
    tabPopup: 'ポップアップ',
    categoryNotice: 'お知らせ',
    categoryPopup: 'ポップアップ',
    categoryEvent: 'イベント',
    priority: '重要',
    colNo: '番号',
    colCategory: 'カテゴリ',
    colTitle: 'タイトル',
    loadingNotice: 'お知らせを読み込み中...',
    loadingEvent: 'イベントを読み込み中...',
    emptyNotice: '登録されたお知らせがありません。',
    emptyEvent: '登録されたイベントがありません。',
    errorNotice: 'お知らせを読み込めませんでした。',
    errorEvent: 'イベントを読み込めませんでした。',
    detailDefaultTitle: 'お知らせ',
    detailLoadError: 'お知らせ内容を読み込めませんでした。'
  },
  betting: {
    title: 'ベット履歴',
    desc: '最近のゲームベット記録を確認します。',
    startDate: '開始日',
    endDate: '終了日',
    gameName: 'ゲーム名',
    gameNamePlaceholder: 'ゲーム名検索',
    search: '照会',
    totalBet: '総ベット',
    totalWin: '総当選',
    profit: '損益',
    loading: 'ベット履歴を読み込み中...',
    loadError: 'ベット履歴を読み込めませんでした。',
    empty: '照会されたベット履歴がありません。',
    colDateTime: '日時',
    colProvider: 'プロバイダー',
    colGameName: 'ゲーム名',
    colCategory: '区分',
    colBetAmount: 'ベット額',
    colWinAmount: '当選額',
    colPreBalance: 'ベット前',
    colAfterBalance: 'ベット後',
    categorySlot: 'スロット',
    categoryLive: 'ライブ',
    categoryFishing: 'フィッシング',
    categoryMini: 'ミニ',
    categorySports: 'スポーツ',
    categoryAll: 'すべて',
    categoryOther: 'その他',
    errorNoLogin: 'ログイン情報がありません。再度ログインしてください。',
    errorNoDateRange: '照会期間を選択してください。',
    errorDateRange: '開始日は終了日より後に設定できません。'
  },
  mypage: {
    title: 'マイページ',
    desc: '会員情報と保有資産を確認できます。',
    loading: '会員情報を読み込み中...',
    loadError: '会員情報を読み込めませんでした。',
    profileTitle: '会員情報',
    walletTitle: '保有資産',
    inquiryTitle: '1対1お問い合わせ',
    inquiryDesc: 'カスタマーサポートお問い合わせ履歴',
    bettingTitle: 'ベット履歴',
    bettingDesc: '最近のゲームベット記録',
    loginId: 'ユーザーID',
    memberLevel: '会員等級',
    name: '氏名',
    phone: '携帯電話番号',
    referralCode: '紹介コード',
    referralCodeEmpty: 'なし',
    bankHolder: '口座名義',
    bankName: '銀行名',
    bankAccount: '口座番号',
    joinDate: '登録日',
    lastLogin: '最終ログイン',
    balance: '保有マネー',
    bonus: 'ボーナス金額',
    apiBalance: 'ゲーム連動残高',
    point: '保有ポイント',
    accountStatus: 'アカウント状態',
    lastDepositDate: '最終入金日',
    lastBetDate: '最終ベット日',
    deposit: '入金',
    withdraw: '出金',
    pointConvert: 'ポイント変換',
    goTo: 'ショートカット',
    pointConvertTitle: 'ポイント変換',
    pointConvertLoading: '残高情報を読み込み中...',
    pointConvertAmount: '変換ポイント',
    pointConvertAmountPlaceholder: '変換するポイントを入力',
    pointConvertAll: '全額',
    pointConvertSubmit: 'ポイント → 保有マネー変換',
    pointConvertSubmitting: '変換中...',
    pointConvertNote1: '保有ポイントを保有マネーに変換します。',
    pointConvertNote2: '申請後すぐに反映されます。',
    pointConvertLoadError: '残高情報を読み込めませんでした。',
    pointConvertAmountRequired: '変換するポイントを入力してください。',
    pointConvertAmountExceed: '保有ポイントを超える金額は変換できません。',
    pointConvertFail: 'ポイント変換に失敗しました。',
    pointConvertSuccess: 'ポイント変換が完了しました。'
  },
  member: {
    role1: '管理者',
    role2: 'マスター',
    role3: 'エージェント',
    role4: 'ルートエージェント',
    role5: 'プレイヤー',
    role6: 'BBS',
    role7: 'CP',
    role8: 'MJ',
    role9: '一般会員',
    levelTemplate: 'レベル{level}',
    statusNormal: '正常',
    statusSuspended: '停止'
  },
  wallet: {
    depositTitle: '入金',
    withdrawTitle: '出金',
    depositTabBank: '口座入金',
    depositTabTether: 'USDT入金',
    withdrawTabBank: '口座出金',
    withdrawTabTether: 'USDT出金',
    depositTabAria: '入金方法',
    withdrawTabAria: '出金方法',
    subtitleBoth: '口座振込またはUSDT（テザー）で入出金を申請できます。',
    subtitleTether: 'USDT（テザー）で入出金を申請できます。',
    subtitleBank: '口座振込で入出金を申請できます。',
    tetherDepositGuideTitle: 'USDT入金案内',
    bankDepositGuideTitle: '口座入金案内',
    bankWithdrawGuideTitle: '口座出金案内',
    tetherWithdrawGuideTitle: 'USDT出金案内',
    tetherDepositGuideParagraph1: 'USDT（テザー）で入金するには、下記で金額と自分のウォレットアドレスを入力して入金申請してください。',
    tetherDepositGuideParagraph2: '申請後に案内されるUSDTアドレス（TRC20）へ送金すると、Bithumb USDTレート基準でウォン金額が反映されます。',
    tetherDepositGuideParagraph3Prefix: 'アドレス・QRに関するお問い合わせは ',
    tetherDepositGuideParagraph3Suffix: ' またはカスタマーサポートまでご連絡ください。',
    bankDepositGuideParagraph1: '口座入金をご利用の場合は、入金金額と口座情報（銀行名・入金者名・口座番号）を入力して申請してください。',
    bankDepositGuideParagraph2: '申請後に案内される専用入金口座へ送金すると、確認・処理されます。',
    bankDepositGuideParagraph3: '他人名義または申請額と異なる金額で入金した場合、確認が遅れることがあります。必ず申請金額と同額を入金してください。',
    bankWithdrawGuideParagraph1: '口座出金は、出金金額と銀行名・口座名義・口座番号を入力して申請してください。',
    bankWithdrawGuideParagraph2Prefix: '登録した口座情報が正確かご確認ください。お問い合わせは ',
    bankWithdrawGuideParagraph2Suffix: ' までご連絡ください。',
    tetherWithdrawGuideParagraph1: 'USDT（テザー）出金は、出金金額とUSDTアドレス（TRC20）を入力して申請してください。',
    tetherWithdrawGuideParagraph2Prefix: '出金手順やUSDTアドレスに関するお問い合わせは ',
    tetherWithdrawGuideParagraph2Suffix: ' までご連絡ください。',
    tetherDepositRequestTitle: 'USDT入金申請',
    bankDepositRequestTitle: '口座入金申請',
    bankWithdrawRequestTitle: '口座出金申請',
    tetherWithdrawRequestTitle: 'USDT出金申請',
    depositAmountLabel: '入金金額',
    withdrawAmountLabel: '出金金額',
    amountPlaceholder: '例：100,000ウォン',
    quick10k: '1万',
    quick30k: '3万',
    quick50k: '5万',
    quick100k: '10万',
    quick500k: '50万',
    reset: '初期化',
    required: '必須',
    checking: '確認中...',
    requesting: '申請中...',
    walletAddressLabel: '自分のウォレットアドレス',
    walletAddressPlaceholder: 'ウォレットアドレスを入力してください',
    walletCheck: 'ウォレット確認',
    walletBalanceLabel: '保有コイン',
    walletBalanceUnit: 'USDT',
    walletCheckHintDeposit: '入金申請前にウォレット確認を押してTRC20 USDT残高を確認してください。',
    walletCheckHintWithdraw: '出金申請前にウォレット確認を押してTRC20 USDT残高を確認してください。',
    tetherAddressLabel: 'USDTアドレス',
    tetherAddressPlaceholder: 'USDT（テザー）TRC20出金アドレスを入力してください',
    bankInfoGroup: '口座情報',
    bankNameLabel: '銀行名',
    bankNamePlaceholder: '例：国民銀行',
    depositorNameLabel: '入金者名',
    depositorNamePlaceholder: '入金者名',
    accountHolderLabel: '口座名義',
    accountHolderPlaceholder: '実名',
    accountNumberLabel: '口座番号',
    accountNumberPlaceholder: 'ハイフン(-)なしで数字のみ入力',
    availableBalanceLabel: '出金可能金額',
    checkAvailableBalance: '出金可能金額を確認',
    depositRequest: '入金申請',
    withdrawRequest: '出金申請',
    supportInquiry: 'カスタマーサポート',
    tetherAddressGuide: 'USDTアドレス案内',
    networkTrc20: 'TRC20',
    networkHint: 'TRC20（トロン）ネットワークでのみ入金してください。',
    requestedAmount: '申請金額：{amount} USDT',
    qrAlt: 'USDT入金QRコード',
    qrLoading: 'QR生成中...',
    qrCaption: 'TRC20 QRスキャン入金',
    copyAddress: 'アドレスをコピー',
    copiedAddress: 'コピー済み',
    addressCopied: 'アドレスをコピーしました。',
    tetherAddressCopied: 'USDTアドレスをコピーしました。',
    addressCopyFail: 'アドレスのコピーに失敗しました。',
    copyBankName: '銀行名をコピー',
    copyAccountNo: '口座番号をコピー',
    copyHolder: '口座名義をコピー',
    bankAccountGuide: '入金口座案内',
    bankDepositHint: '以下の口座に{amount}を入金してください。',
    bankName: '銀行名',
    accountNumber: '口座番号',
    accountHolder: '口座名義',
    depositHistoryTitle: '入金履歴',
    withdrawHistoryTitle: '出金履歴',
    historyDesc: '申請中・完了などすべての履歴が表示されます。',
    historyReloadDeposit: '入金履歴を更新',
    historyReloadWithdraw: '出金履歴を更新',
    loadingDepositHistory: '入金履歴を読み込み中...',
    loadingWithdrawHistory: '出金履歴を読み込み中...',
    loadDepositHistoryError: '入金履歴を読み込めませんでした。',
    loadWithdrawHistoryError: '出金履歴を読み込めませんでした。',
    emptyDepositHistory: '入金履歴がありません。',
    emptyWithdrawHistory: '出金履歴がありません。',
    colRequestDate: '申請日時',
    colType: '区分',
    colAmount: '金額',
    colDepositInfo: '入金情報',
    colWithdrawInfo: '出金情報',
    colMemo: 'メモ',
    colStatus: '状態',
    colProcessedDate: '処理日時',
    statusRequest: '申請',
    statusWaiting: '待機',
    statusComplete: '完了',
    statusCancel: 'キャンセル',
    statusDelete: '削除',
    statusUnknown: '不明',
    chargeTypeNormal: '一般入金申請',
    chargeTypeForce: '強制入金',
    chargeTypeOther: 'その他',
    withdrawTypeNormal: '一般出金',
    withdrawTypeForce: '強制出金',
    withdrawTypeOther: 'その他',
    depositMinAmount: '入金金額は{amount}以上で入力してください。',
    depositWalletRequired: 'ウォレットアドレスを入力してください。',
    depositWalletCheckRequired: 'ウォレット確認を完了してから入金申請してください。',
    depositRateLoading: 'USDT為替情報を読み込み中です。しばらくしてから再度お試しください。',
    depositSuccess: '入金申請を受け付けました。',
    depositFail: '入金申請に失敗しました。しばらくしてから再度お試しください。',
    depositPending: 'すでに入金申請が進行中です。処理完了後に再度申請してください。',
    bankNameRequired: '銀行名を入力してください。',
    depositorRequired: '入金者名を入力してください。',
    accountRequired: '口座番号を入力してください。',
    invalidTronAddress: '正しいTRC20ウォレットアドレスを入力してください。',
    walletBalanceFail: 'ウォレット残高の照会に失敗しました。',
    walletBalanceNetworkFail: 'ウォレット残高の照会に失敗しました。ネットワーク接続を確認してください。',
    depositNoteMismatch: '申請金額と異なる金額で入金した場合、確認に時間がかかることがあります。',
    withdrawMinAmount: '出金金額は{amount}以上で入力してください。',
    withdrawBalanceLoading: '出金可能金額情報を読み込み中です。しばらくしてから再度お試しください。',
    withdrawExceedAvailable: '申請した出金金額が出金可能マネー（{amount}）を超えています。',
    withdrawExceedBalance: '申請した出金金額が出金可能マネーを超えています。出金規定（ベット要件・ボーナス控除）をご確認ください。',
    withdrawPending: 'すでに出金申請が進行中です。処理完了後に再度申請してください。',
    withdrawLimitMinutes: '出金申請は{minutes}分間隔で可能です。しばらくしてから再度お試しください。',
    withdrawLimitGeneric: '出金申請制限時間が経過していません。しばらくしてから再度お試しください。',
    withdrawSuccess: '出金申請を受け付けました。',
    withdrawFail: '出金申請に失敗しました。しばらくしてから再度お試しください。',
    tetherAddressRequired: 'USDTアドレスを入力してください。',
    withdrawWalletCheckRequired: 'ウォレット確認を完了してから出金申請してください。',
    holderRequired: '口座名義を入力してください。',
    availableModalTitle: '出金可能金額案内',
    availableModalLabel: '現在の出金可能金額',
    refreshBalance: '金額を更新',
    amountInfoTitle: '金額情報',
    amountInfoAria: '出金可能金額計算案内',
    totalDeposit: '総入金額',
    totalBet: '総ベット額',
    requiredBet: '必要ベット額（総入金 × {percent}）',
    heldMoney: '保有マネー',
    heldBonus: '保有ボーナス金額',
    withdrawRule: '出金規定',
    formula: '計算式',
    rulesTitle: '出金規定案内',
    ruleMetSummary: 'ベット要件達成 — 保有マネー全額出金可能',
    ruleNotMetSummary: 'ベット要件未達成 — ボーナス控除後に出金',
    formulaCalculating: '出金可能金額を計算中',
    ruleInfoLoading: '出金規定情報を読み込み中です。',
    conditionChecking: '出金条件を確認中です。',
    conditionLoadFail: '出金条件情報を読み込めませんでした。',
    conditionMet: '現在の総ベット額（{totalBet}）が必要ベット額（{requiredBet}）を上回っているため、保有マネー全額の出金が可能です。',
    conditionNotMet: '現在の総ベット額（{totalBet}）が必要ベット額（{requiredBet}）以下のため、出金可能マネーは保有マネーからボーナスを差し引いた金額に制限されます。',
    ruleBetMetTitle: 'ベット要件達成',
    ruleBetMetDesc: '総ベット額が総入金額 × {percent}を超える場合、保有マネー全額まで出金申請できます。',
    ruleBetNotMetTitle: 'ベット要件未達成',
    ruleBetNotMetDesc: '総ベット額が基準以下の場合、出金可能マネーは保有マネー − ボーナス金額に制限されます。',
    ruleTotalDepositNote: '出金申請・処理時に申請した出金金額分が差し引かれます。',
    ruleTotalBetNote: '入金後最初の出金前まで累積されたベット金額で、出金処理時に0にリセットされます。',
    amountWon: '{amount}ウォン',
    rateLabel: 'Bithumb 1 USDT = {rate}',
    rateLive: 'リアルタイム',
    rateConnectFail: 'Bithumb為替レートへの接続に失敗しました。',
    rateDisconnected: 'Bithumb為替レート接続が切断されました。',
    chargeMemo: '入金額{krw} = {usdt}USDT入金申請',
    withdrawMemo: '出金額{krw} = {usdt}USDT出金申請'
  },
  lang: {
    title: '言語設定',
    changed: '言語を変更しました。'
  },
  payment: {
    depositSubtitleBoth: '口座振込またはUSDT（テザー）で入金を申請できます。',
    depositSubtitleTether: 'USDT（テザー）で入金を申請できます。',
    depositSubtitleBank: '口座振込で入金を申請できます。',
    withdrawSubtitleBoth: '口座振込またはUSDT（テザー）で出金を申請できます。',
    withdrawSubtitleTether: 'USDT（テザー）で出金を申請できます。',
    withdrawSubtitleBank: '口座振込で出金を申請できます。'
  }
}
